import { memoizeOne } from 'mk2/helpers/cache';
import { AppState } from 'mk2/reducers';
import { BlogPostEntity } from 'mk2/schemas';
import {
    initialGroupReportedFeedPageState,
    initialGroupReportedFeedState,
    initialGroupReportedFeedVirtualPageState,
    initialPostsState,
} from './GroupReportedFeed.constants';
import { GroupReportedFeedPageState, GroupReportedFeedVirtualPageState } from './GroupReportedFeed.reducers';

export const getGroupReportedFeedState = (state: AppState, groupId: number) => {
    if (!state.containers.groups.groupReportedFeed[groupId]) {
        return initialGroupReportedFeedState;
    }

    return state.containers.groups.groupReportedFeed[groupId];
};

export const getGroupReportedFeedSearchState = (state: AppState, groupId: number) => {
    const groupReportedFeedState = getGroupReportedFeedState(state, groupId);

    if (!groupReportedFeedState.posts) {
        return initialPostsState;
    }

    return groupReportedFeedState.posts;
};

export const getGroupReportedFeedPageState = (state: AppState, groupId: number, page: number): GroupReportedFeedPageState => (
    getGroupReportedFeedSearchState(state, groupId).pages[page] || initialGroupReportedFeedPageState
);
export const getGroupReportedFeedVirtualPageState = (state: AppState, groupId: number, pageName: string): GroupReportedFeedVirtualPageState => (
    getGroupReportedFeedSearchState(state, groupId).virtualPages[pageName] || initialGroupReportedFeedVirtualPageState
);

export const getImageIdsFromPosts = memoizeOne((posts: BlogPostEntity[]): number[] => {
    return posts.reduce((acc, post) => {
        acc.push(...(post.images.map((image) => image.id)));
        return acc;
    }, []);
});
